import './MessageModalModal.scss';
import { Modal, ModalBody } from 'reactstrap';
import InstructionBubble from '../Displays/InstructionBubble/InstructionBubble';
import { AlpLogoSpinningCryingGif, AlpLogoSpinningSmileGif } from '@project/helpers/imagePreloader';

export enum MessageModalModalType {
  'success', 'error'
}
interface MessageModalModalProps {
  type: MessageModalModalType,
  show: boolean;
  onClose(): void;
  header: any;
  content: any;
}

function MessageModalModal({ type, show, onClose, header, content }: MessageModalModalProps) {
  
  const movingPic = () => {
    switch(type) {
      case MessageModalModalType.error: return AlpLogoSpinningCryingGif;
      case MessageModalModalType.success: return AlpLogoSpinningSmileGif;
    }
  }

  return (
    <Modal className="alp-modal" isOpen={show} toggle={() => onClose()} backdrop="static" centered>
      <ModalBody>
        <InstructionBubble movingpic={movingPic()}>
          <>
            <div className="flex-space-between">
              <h6 className="green fw-bold" dangerouslySetInnerHTML={{ __html: header }}></h6>
              <i className="icon icon-close clickable" onClick={() => onClose()} />
            </div>
            <div dangerouslySetInnerHTML={{ __html: content }}></div>
          </>
        </InstructionBubble>
      </ModalBody>
    </Modal>
  );
}

export default MessageModalModal;
